<template>
    <div>
        <div class="text-center mt-4">
            <img border="0" :src="imgPath" width="120" height="120" alt="">
        </div>
        <div class="text-center mt-4 font-weight-bold">Webviewで{{ pageName }}を表示する</div>
    </div>
</template>

<script>
export default {
    props: {
        //
    },
    data () {
        return {
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png",
            pageName: ""
        }
    },
    watch: {
        //
    },
    created () {
        let path = this.$route.path;
        switch (path) {
            case "/app/mypage-reserve-reference":
                this.pageName = "予約詳細";
                this.setDataMypageReserveReference();
                break;
            case "/app/mypage-reserve-update":
                this.pageName = "予約変更";
                this.setDataMypageReserveUpdate();
                break;
            case "/app/companion-list":
                this.pageName = "同伴者リスト";
                this.setDataCompanionList();
                break;
            default:
                this.pageName = "システムエラー";
                break;
        }
    },
    methods: {
        /** ----------------------------------------------
         * 予約詳細開示処理
         * ---------------------------------------------- */
        async setDataMypageReserveReference () {
            this.$store.commit("mypage/pushReserveNo", this.$store.state.auth.mobileAppReserveNo);
            this.$router.push({ path: '/mypage-reserve-reference' });
        },
        /** ----------------------------------------------
         * 予約変更開示処理
         * ---------------------------------------------- */
        async setDataMypageReserveUpdate () {
            sessionStorage.setItem("MyPage.reserveBranchNo", 0);
            this.$store.commit("mypage/pushReserveNo", this.$store.state.auth.mobileAppReserveNo);
            sessionStorage.setItem("MyPage.returnBackUrl", "/mypage-reserve-update");
            this.$router.push({ path: '/mypage-reserve-update' });
        },
        /** ----------------------------------------------
         * 同伴者リスト開示処理
         * ---------------------------------------------- */
        async setDataCompanionList () {
            sessionStorage.setItem("MyPage.reserveBranchNo", 0);
            sessionStorage.setItem("MyPage.returnBackUrl", "/mypage-reserve-update");
            sessionStorage.setItem('Reserve.reserveNo', this.$store.state.auth.mobileAppReserveNo);
            sessionStorage.setItem('Reserve.reserveType','1');
            sessionStorage.setItem('MyPage.companionChangeFlg', 1);
            this.$router.push({ path: "/companion-list" });
        }
    }
}
</script>

<style scoped>
</style>
